import { Checkbox as BaseCheckbox } from "../../../ui/checkbox";
import { Label } from "../../../ui/label";
import { cn } from "../../../../lib/utils";
import type { CheckboxProps } from "./types";

function Checkbox({ id, children, className, wrapperClassName, disabled, ...props }: CheckboxProps) {
    return (
        <div className={cn("tw-flex tw-items-center tw-gap-2", disabled && "tw-opacity-70", wrapperClassName)}>
            <BaseCheckbox
                id={id}
                disabled={disabled}
                className={cn("tw-cursor-pointer disabled:tw-cursor-not-allowed tw-rounded-sm", className)}
                {...props}
            />
            {children && (
                <Label
                    htmlFor={id}
                    className="tw-flex tw-h-4 tw-translate-y-1 tw-cursor-pointer tw-items-center tw-text-sm tw-font-normal tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70"
                >
                    {children}
                </Label>
            )}
        </div>
    );
}

export default Checkbox;
